<template>
	<div class="body-bg slot-page py-4">
		<BackToTop />
		<div
			class="form-group p-2 d-flex align-items-center"
			style="gap: .5rem; border-radius: 20px; overflow: hidden;;"
		>
			<div
				class="w-50 d-flex align-items-center justify-content-center"
				style="cursor: pointer; color: #fff"
				@click="isProviderDialogOpened = true"
			>
				<p
					class="mb-0 px-2 text-center"
					style="font-size: 1.1rem;"
				>{{ selectedProvider }}</p>
				<van-icon
					style="transform: rotate(90deg);"
					name="play"
					size="16px"
				/>
			</div>
			<van-dialog
				v-model:show="isProviderDialogOpened"
				title="Search"
				:showConfirmButton="false"
				class="games-search-dialog"
			>
				<template #title>
					<div class="position-relative p-0">
						<h3 class="m-0">Select Provider</h3>
						<button
							class="close-btn"
							@click="isProviderDialogOpened = false"
						>
							<van-icon
								name="close"
								size="20px"
							/>
						</button>
					</div>
				</template>
				<div class="container-fluid my-4">
					<div class="row m-0">
						<div
							class="col-12 py-2 px-4 mb-3 bg-primary provider-item"
							:class="{ active: provider.value === $route.query.provider }"
							v-for="(provider, index) in providerOptions"
							@click="changeProvider(provider.value)"
						>
							<p class="mb-0 font-weight-bold">
								{{ provider.text }}
							</p>
						</div>
					</div>
				</div>
			</van-dialog>
			<button
				type="button"
				class="main-btn w-100"
				@click="isSearchDialogOpened = true"
			>
				{{ $t('home.search_game') }}
			</button>

			<van-dialog
				v-model:show="isSearchDialogOpened"
				title="Search"
				:show-confirm-button="false"
				@close="newGames = []"
				class="games-search-dialog"
			>
				<template #title>
					<div class="position-relative p-0">
						<h3 class="m-0">Search</h3>
						<button
							class="close-btn"
							@click="isSearchDialogOpened = false"
						>
							<van-icon
								name="close"
								size="20px"
							/>
						</button>
					</div>
				</template>
				<div class="container-fluid">
					<div class="form-group my-4">
						<input
							v-model="name"
							type="text"
							class="text-center custom-input w-100"
							:placeholder="$t('home.search_game')"
						>
					</div>
					<div class="row m-0">
						<template v-if="isGameListLoading">
							<GameCardSkeleton
								v-for="n in 16"
								:key="n"
							/>
						</template>
						<template v-else>
							<GameCard
								v-for="(game, index) in newGames.length > 0 ? newGames : games"
								:key="index"
								:game="game"
								:provider="$route.query.provider"
								@toggle-favorite="toggleFavorite"
								@handle-play="gameInit(game)"
							/>
						</template>
					</div>
				</div>
			</van-dialog>
		</div>

		<div class="container-fluid">
			<div class="row">
				<template v-if="isGameListLoading">
					<GameCardSkeleton
						v-for="n in 16"
						:key="n"
					/>
				</template>
				<template v-else>
					<GameCard
						v-for="(game, index) in newGames.length > 0 ? newGames : games"
						:key="index"
						:game="game"
						:provider="$route.query.provider"
						@toggle-favorite="toggleFavorite"
						@handle-play="gameInit(game)"
					/>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import { Sticky, Dialog } from 'vant';
import { mapActions } from 'vuex';
import SkeletonImage from '../../components/SkeletonImage.vue';
import BackToTop from '../../components/BackToTop.vue';
import GameCard from '../../components/GameCard.vue';
import GameCardSkeleton from '../../components/GameCardSkeleton.vue';

export default {
	components: {
		Sticky,
		SkeletonImage,
		BackToTop,
		GameCard,
		GameCardSkeleton
	},

	data() {
		return {
			games: [],
			rows: 0,
			provider: 'Pragmatic',
			isSearchDialogOpened: false,
			isProviderDialogOpened: false,
			selectedProvider: this.$route.query.provider || "",
			providerOptions: [
				{ text: "Pragmatic", value: "Pragmatic" },
				{ text: "Buffalo", value: "Buffalo" },
				{ text: "Jili", value: "Jili" },
				{ text: "Playstar", value: "Playstar" },
				{ text: "KA", value: "KA" },
				{ text: "JOKER", value: "JOKER" },
				{ text: "FaChai", value: "FaChai" },
				{ text: "Spade", value: "Spade" },
				{ text: "JDB", value: "JDB" },
				{ text: "5G", value: "5G" },
				{ text: "AceWin", value: "AceWin" },
				{ text: "2J", value: "2J" },
				{ text: "VA", value: "VA" },
			],
			name: null,
			newGames: [],
			isGameListLoading: false,
		};
	},
	methods: {
		...mapActions(['fetchUser']),
		toggleFavorite(game) {
			if (!game.hasOwnProperty('isFavorite')) {
				this.$set(game, 'isFavorite', false);
				game.isFavorite = true;
			} else {
				game.isFavorite = !game.isFavorite;
			}
		},
		imageLinkGenerate(gameId, type) {
			if (type === 'Jili') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jili/${gameId}.webp`;
			} if (type === 'Rich88') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich88/${gameId}.webp`;
			} if (type === 'Live22') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/live22/${gameId}.webp`;
			} if (type === 'Spade') {
				return `https://merchantapi.silverkirin88.com/thumbnail/en_US/${gameId}.jpg`;
			} if (type === 'Fastspin') {
				return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${gameId}.jpg`;
			} if (type === 'Playstar') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/playstar/${gameId}.webp`;
			} if (type === 'FaChai') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/fachai/${gameId}.webp`;
			} if (type === 'PGSoft') {
				return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/pgsoft_${gameId}.webp`;
			} if (type === 'JOKER' || type === 'Joker') {
				return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/joker/${gameId}.webp`;
			} if (type === '5G') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/5g/${gameId}.webp`;
			} if (type === 'KA') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/newKA/${gameId}.webp`;
			} if (type === 'AceWin') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/acewin/${gameId}_EN.webp`;
			} if (type === 'JDB') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jdb/${gameId}.webp`;
			} if (type === 'Buffalo') {
				return this.buffaloImage(gameId, provider)
				// return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/${gameId}.webp`;
			} if (type === 'HotDog') {
				return `https://res.hotdog-gaming.com/banners/380x500/${gameId}.png`;
			} if (type === 'Rich') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich/${gameId}.webp`;
			} if (type === 'CQ9' || type === 'cq9' || type === 'SexySlot') {
				return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/cq9/cq9_${gameId}.webp`;
			} if (type === 'BTG') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/btg/${gameId}.webp`;
			} if (type === 'BNG') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/bng/${gameId}.webp`;
			}if (type === '2J') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/2j/${gameId}.webp`;
			} if (type === 'VA') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/va/${gameId}_en.webp`;
			} if (type === 'Buffalo') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/${gameId}.webp`;
			} if (type === 'AFGame') {
				return `https://cdn.myanmarshankoeme.com/build/assets/img/AFG-Square/${gameId}.webp`;
			}

			return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${gameId}.webp`;
		},
		detectMob() {
			let check = false;
			/* eslint-disable */
			(function (a) {
				if (
					/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
						a,
					)
					|| /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
						a.substr(0, 4),
					)
				) { check = true; }
			}(navigator.userAgent || navigator.vendor || window.opera));
			return check;
		},

		async fetchGames() {
			try {
				this.isGameListLoading = true;
				// this.$store.commit('setLoading', true);

				const res = await axios.get('/games', {
					params: {
						provider: this.$route.query.provider,
					},
				});
				this.games = res.data.data;

				// Filter games
				this.games = this.games.filter((game) => game.gameTypeID.includes('vs'));
				this.games.forEach(game => {
					if (!game.playerCount) {
						game.playerCount = Math.floor(Math.random() * (100 - 10 + 1)) + 10;
					}
				});

				// this.games.push(this.games.shift());

				// if (this.$route.query.provider === 'Pragmatic') {
				// 	let games = this.games;

				// 	// Cut the last 10 elements
				// 	let lastTenGames = games.slice(-10);

				// 	// Get the remaining elements (excluding the last 10)
				// 	let remainingGames = games.slice(0, -10); // Fixed this line

				// 	// Merge the last 10 games at the beginning with the remaining games
				// 	let reorderedGames = lastTenGames.concat(remainingGames);

				// 	// Update games with reordered array
				// 	this.games = reorderedGames;
				// }

				// setTimeout(() => {
				// 	console.log("HELLO");
				// }, 3000);

				// this.$store.commit('setLoading', false);
				this.isGameListLoading = false;
			} catch (error) {
				// this.$store.commit('setLoading', false);
				this.isGameListLoading = false;
				console.log(error);
			}
		},

		async gameInit(game, isTest = false) {
			try {
				this.$store.commit('setLoading', true);
				const authUser = await this.fetchUser();
				if (!authUser) {
					this.$router.push('/auth/login');
					this.$store.commit('setLoading', false);
					return;
				}
				if (authUser && !authUser.is_verified) {
					this.$router.push('/auth/verify');
					this.$store.commit('setLoading', false);
					return;
				}

				const playType = isTest ? 'demo' : 'real';
				const res = await axios.get('/games/url', {
					params: {
						gameID: game.gameID,
						provider: game.provider || this.$route.query.provider,
						type: playType,
					},
					headers: {
						Authorization: `Bearer ${localStorage.getItem('token')}`,
					},
				});

				const data = res?.data?.data ?? res?.data ?? {};
				const apiDescription =
					data?.description ??
					res?.data?.description ??
					data?.message ??
					res?.data?.message ??
					'';
				let gameUrl =
					data.gameUrl ??
					data.game_url ??
					data.url ??
					res?.data?.gameUrl ??
					res?.data?.url ??
					'';
				gameUrl = String(gameUrl || '').trim();

				// PGSoft and some providers return HTML instead of a URL.
				let rawHtml =
					data.html ??
					res?.data?.html ??
					(typeof res?.data === 'string' && res.data.trimStart().startsWith('<')
						? res.data
						: null) ??
					(gameUrl && gameUrl.trimStart().startsWith('<') ? gameUrl : null);
				if (!rawHtml) rawHtml = '';
				if (rawHtml && typeof rawHtml === 'string') {
					const blob = new Blob([rawHtml], { type: 'text/html;charset=utf-8' });
					gameUrl = URL.createObjectURL(blob);
				}

				if (gameUrl) {
					this.$store.commit('setIframeURL', gameUrl);
					this.$router.push('/iframeURL');
				} else {
					Dialog.alert({
						title: 'အကြောင်းကြားချက်',
						message: String(apiDescription).trim() || 'ဂိမ်းလင့်မရရှိပါ။ Customer service သို့ ဆက်သွယ်ပေးပါ။',
						confirmButtonText: 'OK',
					});
				}

				this.$store.commit('setLoading', false);
			} catch (error) {
				this.$store.commit('setLoading', false);
				const message =
					error?.response?.data?.message ||
					error?.response?.data?.description ||
					'ဂိမ်းဖွင့်၍ မရပါ။ ထပ်မံကြိုးစားကြည့်ပါ။';
				Dialog.alert({
					title: 'အကြောင်းကြားချက်',
					message,
					confirmButtonText: 'OK',
				});
			}
		},
		changeProvider(value) {
			console.log("PROVIDRE", this.$route.query.provider);
			console.log("Value", value);
			if (this.$route.query.provider === value) {
				this.isProviderDialogOpened = false
			} else {
				this.isProviderDialogOpened = false
				this.$router.push({
					query: { ...this.$route.query, provider: value }
				});
			}
		},
	},
	watch: {
		provider() {
			this.fetchGames();
			//   this.newGames = this.games.filter((game) => game.provider.includes(this.provider));
		},
		name() {
			this.newGames = this.games.filter((game) => game.gameName.toLowerCase().includes(this.name.toLowerCase()));
		},
		"$route.query.provider": {
			immediate: true,
			handler(newProvider) {
				this.selectedProvider = newProvider || "";
				this.$store.commit('setLoading', true);
				this.fetchGames();
				this.$store.commit('setLoading', false);

			},
		},
	},
	async mounted() {
		// this.$store.commit('setLoading', true);
		// await this.fetchGames();
		// this.$store.commit('setLoading', false);
	},
};
</script>
<style scoped>
.body-bg {
	overflow-x: hidden;
	padding-bottom: 15rem;
	background: #2B0000;
	min-height: 100vh;
}

.game-provider-dropdown {
	border: 4px solid red;

	.van-dropdown-menu__bar {
		background-color: none !important;
		box-shadow: none !important;
	}

	.van-dropdown-menu__title {
		color: #02afff !important;
	}
}

.games-search-dialog {
	width: 100% !important;
	height: 100vh;
	inset: 0 !important;
	border-radius: 0;
	overflow-y: auto;
	transform: translate(0, 0);
	scrollbar-width: none;
	background: #2B0000;

	h3 {
		font-size: 1.2rem;
	}

	.close-btn {
		position: absolute;
		top: 0;
		right: 10px;
		background: transparent;
		border: none;
		cursor: pointer;
	}
}

.provider-item {
	background: gainsboro;
	border-radius: 4px;
	cursor: pointer;

	&.active {
		background: #d4c23f;
		;
		color: black;
	}
}

@keyframes blinker {
	50% {
		opacity: .4;
	}
}
</style>
